import styled from 'styled-components';

export default styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
`;
